import { render, staticRenderFns } from "./GWalletIcon.vue?vue&type=template&id=0af7add5&"
import script from "./GWalletIcon.vue?vue&type=script&lang=js&"
export * from "./GWalletIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports